export const Affiliate = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <section className="text-center mb-20">
          <div className="mb-8">
            <img 
              src="/logo/logo-glossy.png" 
              alt="RiverBlue Logo" 
              className="w-24 h-24 mx-auto mb-6 drop-shadow-[0_0_20px_rgba(59,130,246,0.4)] drop-shadow-[0_0_40px_rgba(59,130,246,0.3)] filter brightness-110 contrast-105"
              style={{
                filter: 'drop-shadow(0 0 20px rgba(59, 130, 246, 0.4)) drop-shadow(0 0 40px rgba(59, 130, 246, 0.3)) brightness(1.1) contrast(1.05) saturate(1.1)',
              }}
            />
          </div>
          <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-4 bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent leading-[1.1] pb-1 overflow-visible">
            Affiliate Portal
          </h1>
          <p className="text-xl sm:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Partner with RiverBlue to earn commissions by referring clients.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:info@riverblue.io?subject=Affiliate%20Program%20Inquiry&body=Hi%20RiverBlue%20team,%0D%0A%0D%0AI%27m%20interested%20in%20your%20affiliate%20program.%0D%0A%0D%0AName:%0D%0AEmail:%0D%0ACompany%20(if%20applicable):%0D%0A%0D%0AThanks,"
              className="px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all shadow-lg shadow-blue-500/30 hover:shadow-xl hover:shadow-blue-500/40 text-center transform hover:scale-105"
            >
              Contact Us
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};
